import { status } from './fileUploaderReducer';

export const uploadingAction = (dispatch) => (queueId, { name }) =>
  dispatch({
    type: status.UPLOADING,
    value: {
      queueId,
      name,
    },
  });

export const uploadedAction = (dispatch) => (queueId, { id, url }) =>
  dispatch({
    type: status.UPLOADED,
    value: {
      queueId,
      url,
      id,
    },
  });

export const notUploadedAction = (dispatch) => (queueId, { message }) =>
  dispatch({
    type: status.NOTUPLOADED,
    value: {
      queueId,
      message,
    },
  });

export const removeItemAction = (dispatch) => (queueId) =>
  dispatch({
    type: status.REMOVE,
    value: {
      queueId,
    },
  });

export const deletingAction = (dispatch) => (queueId) =>
  dispatch({
    type: status.DELETING,
    value: {
      queueId,
    },
  });

export const notDeletedAction = (dispatch) => (queueId, { message }) =>
  dispatch({
    type: status.NOTDELETED,
    value: {
      queueId,
      message,
    },
  });
